<div class="container">
    <div class="header">
        <div class="vehicle-info page-header" i18n>Vehicle Information</div>
        <div class="vehicle-details-text page-content" i18n>
            Enter your vehicle details. This will help us prepare for your appointment.
        </div>
        <div class="required-fields page-content" i18n>
            Fields marked <span class="star-icon page-content">*</span> are required
        </div>
    </div>

    <div class="container-body">
        <div class="details page-header" i18n>Details</div>
        <div class="vehicle-info-form-container">
            <form [formGroup]="vehicleInfoForm">
                <mat-form-field appearance="outline"
                    [ngClass]="vehicleInfoForm.get('type')?.invalid && vehicleInfoForm.get('type')?.touched ? 'required-field' : 'normal-field'">
                    <mat-label class="page-label" i18n>Vehicle Type</mat-label>
                    <mat-select formControlName="type" name="type" [placeholder]="selectvehicleType">
                        @for (department of departments; track departments) {
                        <mat-option [value]="department.code">{{department.description}}</mat-option>
                        }
                    </mat-select>
                    <mat-error>
                        {{ validationMessages.type.required }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline"
                    [ngClass]="vehicleInfoForm.get('make')?.invalid && vehicleInfoForm.get('make')?.touched ? 'required-field form-field-error' : 'normal-field'">
                    <mat-label class="page-label" i18n>Vehicle Make</mat-label>
                    <mat-select formControlName="make" name="make" [placeholder]="selectMake">
                        @for (make of makes; track makes) {
                        <mat-option [value]="make.code">{{make.description}}</mat-option>
                        }
                    </mat-select>
                    <mat-error>
                        {{ validationMessages.make.required }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="example-form-field"
                    [ngClass]="vehicleInfoForm.get('licenseNo')?.invalid && vehicleInfoForm.get('licenseNo')?.touched ? 'required-field form-field-error' : 'normal-field'">
                    <mat-label class="page-label" i18n>License No.</mat-label>
                    <input matInput formControlName="licenseNo" type="text" maxlength="15" [placeholder]="licenseNumberHint">
                    <mat-error>
                        {{ validationMessages.licenseNo.required }}
                    </mat-error>
                    @if (vehicleInfoForm.get('licenseNo')?.hasError('maxlength')) {
                    <mat-error>
                        {{ validationMessages.licenseNo.maxlength }}
                    </mat-error>
                    }
                </mat-form-field>

                <mat-form-field appearance="outline" class="example-form-field"
                    [ngClass]="vehicleInfoForm.get('vin')?.invalid && vehicleInfoForm.get('vin')?.touched ? 'required-field' : 'normal-field'">
                    <mat-label class="page-label" i18n>VIN (optional)</mat-label>
                    <input matInput formControlName="vin" type="text" maxlength="17" [placeholder]="vinHint">
                    <mat-hint align="start" class="page-hint" i18n>
                        VIN is your vehicle's unique identification number
                    </mat-hint>
                    @if (vehicleInfoForm.get('vin')?.hasError('maxlength')) {
                    <mat-error>
                        {{ validationMessages.vin.maxlength }}
                    </mat-error>
                    }
                </mat-form-field>
            </form>
        </div>
    </div>
</div>